import {
  Skeleton as ChakraSkeleton,
  SkeletonProps as ChakraSkeletonProps,
} from "@chakra-ui/react";
import type { SkeletonSharedProps } from "./Skeleton.props";

export default function Skeleton({
  fadeDuration: _fadeDuration,
  startColor: _startColor,
  endColor: _endColor,
  isLoaded,
  loaded,
  variant,
  loading,
  ...props
}: SkeletonProps): JSX.Element {
  let loadingValue: ChakraSkeletonProps["loading"] | undefined = loading;
  if (loadingValue === undefined && loaded !== undefined) {
    loadingValue = !loaded;
  }
  if (loadingValue === undefined && isLoaded !== undefined) {
    loadingValue = !isLoaded;
  }

  const v3Variant: ChakraSkeletonProps["variant"] =
    variant && (variant === "shine" || variant === "none") ? variant : "pulse";

  const loadingStyles = loadingValue
    ? {
        background: "gray.300",
        borderRadius: "md",
      }
    : {};

  return (
    <ChakraSkeleton
      {...loadingStyles}
      {...props}
      // v3 Skeleton doesn't accept start/end colors; keep props for API stability.
      // v3 doesn't accept numeric fade duration directly; kept for API stability.
      // (if needed, we can implement token-based animation styles later)
      loading={loadingValue}
      variant={v3Variant}
    />
  );
}

export type SkeletonProps = SkeletonSharedProps &
  Omit<ChakraSkeletonProps, "variant">;
